// chat feature
export default {
  'Camera not found, please check your browser settings.':
  'Camera not found, please check your browser settings。',
  Send: 'Send',
  'Please type something...': 'Please type here...',
  Picture: 'Picture',
  File: 'File',
  'You have a new message': 'New message',
  'Click to check': 'View',
  'Online Service': 'Service',
  'Customer service': 'Customer Service',
  'Chat features will not work if you keep using IE, please try other brwosers': 'Audio and video chat is not available, Google Chrome is recommended',
  'You are going to invate': '',
  'with someones invitation': 'You are going to invite the exhibitor to be your contacts.',
  'According to the platform analyze': 'You may also send your name card to this exhibitor by instant message to get their confirmation easier.',
  'Chat now': 'Communicate now：',
  'Send message': 'Send message',
  'waiting for someones response': 'Waiting for {0} to accept request',
  'chat with someone': 'Calling with {0}',
  'request': 'Request',
  'video': 'Video',
  'audio': 'Audio',
  'calling': 'Call',
  'Someone chat history': '{0}\'s chat history'
}